"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TableauEvent {
    constructor(type) {
        this._type = type;
    }
    get type() {
        return this._type;
    }
}
exports.TableauEvent = TableauEvent;
//# sourceMappingURL=TableauEvent.js.map